module.exports = __webpack_public_path__ + "img/portraits_with_smartphone_splash.43f023ec.jpg";